// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { SolidBrush } from '@shared/commons/Graphics';
export class ToolViewUtils {
    static DrawFibonacciText(gr, ww, x, y, text, font, color) {
        const clientRect = ww.ClientRectangle;
        y = y - font.Height - 1;
        if (x < clientRect.X + clientRect.Width) {
            const br = new SolidBrush(color);
            gr.DrawString(text, font, br, x, y);
        }
    }
    static FormatFibonacciText(fibLevel, points, instrument) {
        const fibText = fibLevel.toString();
        const p1Y = points[1][1];
        const price = p1Y + (fibLevel / 100) * (points[0][1] - p1Y);
        return fibText.replace('%$', instrument.formatPrice(price));
    }
    static FormatPrice(instrument, price) {
        return instrument.formatPrice(instrument.roundPrice(price));
    }
}
